module.exports = __webpack_public_path__ + "static/flags/VI-f1dcf7fc417864516ce8a9b27afa5d66.gif";